let isEnabled = false;

export function getIsNewBoostedOddDisplayEnabled(): boolean {
    return isEnabled;
}

export function setIsNewBoostedOddDisplayEnabled(value: boolean): void {
    isEnabled = value;
}
